import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import EnableTwoFactorForm from "../forms/EnableTwoFactorForm";
import { selectUser } from "../../redux/auth/selectors";

class _TwoFactor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static propTypes = {
    user: PropTypes.object
  };

  render() {
    return (
      <div
        className="m-portlet__body m-form m-form--fit m-form--label-align-right"
        style={{
          paddingLeft: "0px",
          paddingRight: "0px"
        }}
      >
        <EnableTwoFactorForm
          user={this.props.user}
          onSubmit={this._handlePasswordChange}
          isSubmitting={this.state.passwordProcessing}
        />
      </div>
    );
  }
}

const mapStateToProps = function(state) {
  return {
    user: selectUser(state)
  };
};

const TwoFactor = connect(mapStateToProps)(_TwoFactor);

export default TwoFactor;
